export default "__VITE_ASSET__BEf_xjBA__"